import { useEffect, useState } from "react";
import axios from "axios";
import { Activity } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function VisitorCounter() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/analytics/public-count`)
      .then((res) => setCount(res.data.total))
      .catch(() => {});
  }, []);

  if (count === null) return null;

  return (
    <div className="flex items-center gap-2 text-xs text-zinc-600 font-mono-data" data-testid="visitor-counter">
      <Activity className="w-3.5 h-3.5 text-[#00FF66]" strokeWidth={1.5} />
      <span data-testid="visitor-counter-value">{count.toLocaleString("ru-RU")} посещений сайта</span>
    </div>
  );
}
